<template>
  <ss-modal
    v-show="isModalVisible"
    class="xl"
    title="Przedstawiciel"
    intro="bounceIn"
    outro="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      <template v-if="representativeIndex === null">
        Dodawanie przedstawiciela
      </template>
      <template v-else>
        Edycja przedstawiciela
      </template>
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <div class="position-relative">
        <d-alert
          v-if="loadError"
          show
          theme="warning"
          class="my-4">
          Wczytywanie danych nie powiodło się.
          <a
            href="javascript:window.location.reload();"
            class="alert-link">
            Odśwież stronę
          </a>
          aby spróbować ponownie.
        </d-alert>
        <template v-else>
          <div
            v-if="!isAllDataLoaded"
            class="overlay-loading rounded-0">
            <h2 class="preloader isLoading">Trwa ładowanie</h2>
          </div>

          <d-form>
            <d-row
              v-if="representativeIndex === null"
              class="mb-4">
              <d-col md="6" class="d-flex">
                <d-form-radio
                  name="isNewRep"
                  v-model="isNewRep"
                  :value="true"
                  default
                  inline
                  class="mr-auto">
                  Nowy przedstawiciel
                </d-form-radio>
                <d-form-radio
                  name="isNewRep"
                  v-model="isNewRep"
                  :value="false"
                  default
                  inline>
                  Istniejący przedstawiciel
                </d-form-radio>
              </d-col>
              <d-col md="6" class="d-flex">
                <v-select
                  v-model="data.id"
                  :options="allRepresentativesLite"
                  :reduce="(option) => option.id"
                  :disabled="isNewRep"
                  :selectable="(option) => !allClientRepresentativesIds.includes(option.id)"
                  placeholder="Przedstawiciel"
                  class="autocomplete-wrapper w-100"
                  label="surname"
                  @input="fetchRepresentative">
                  <template
                    slot="selected-option"
                    slot-scope="option">
                    {{ option.name }} {{ option.surname }}
                  </template>
                  <template
                    slot="option"
                    slot-scope="option">
                    {{ option.name }} {{ option.surname }}
                  </template>
                  <template slot="no-options">
                    Brak wyników
                  </template>
                </v-select>
              </d-col>
            </d-row>
            <d-row class="mb-3">
              <d-col md="10">
                <d-alert
                  v-if="isEditEnabled && !isNewRep"
                  show
                  theme="warning"
                  class="mt-1 mb-3 py-1">
                  Modyfikacje przedstawiciela będą widoczne u wszystkich klientów, którzy z niego korzystają.
                </d-alert>
              </d-col>
              <d-col md="2" class="d-flex">
                <d-button
                  @click.prevent="isEditEnabled = true"
                  theme="primary"
                  class="ml-auto my-auto"
                  :disabled="isNewRep || !data.id || !isModalVisible">
                  <i class="material-icons">edit</i>Edytuj
                </d-button>
              </d-col>
            </d-row>

            <d-row>
              <d-col md="6" class="form-group">
                <ss-input
                  v-validate="'required'"
                  v-model="data.name"
                  name="name"
                  label="Imię"
                  placeholder="Imię"
                  :class="{'is-invalid' : errors.has('name') }"
                  :disabled="!isEditEnabled">
                </ss-input>
                <div class="invalid-feedback">{{ errors.first('name') }}</div>
              </d-col>
              <d-col md="6" class="form-group">
                <ss-input
                  v-validate="'required'"
                  v-model="data.surname"
                  name="surname"
                  label="Nazwisko"
                  placeholder="Nazwisko"
                  :class="{'is-invalid' : errors.has('surname') }"
                  :disabled="!isEditEnabled">
                </ss-input>
                <div class="invalid-feedback">{{ errors.first('surname') }}</div>
              </d-col>
            </d-row>

            <d-row>
              <d-col md="6" class="form-group">
                <ss-input
                  v-validate="'email'"
                  v-model="data.email"
                  name="email"
                  label="Email"
                  placeholder="Email"
                  :class="{'is-invalid' : errors.has('email') }"
                  :disabled="!isEditEnabled">
                </ss-input>
                <div class="invalid-feedback">{{ errors.first('email') }}</div>
              </d-col>
              <d-col md="6" class="form-group">
                <label for="phone">Telefon</label>
                <input
                  id="phone"
                  type="text"
                  class="form-control"
                  name="phone"
                  v-model="data.phone"
                  placeholder="Nr telefonu"
                  :disabled="!isEditEnabled"/>
              </d-col>
            </d-row>
            <d-row>
              <d-col md="6">
                <div class="mb-4">
                  <label>Typ dokumentu tożsamości</label>
                  <div v-for="idDocType in idDocumentsTypes">
                    <d-form-radio
                      name="id_card_type"
                      v-model="data.id_card_type"
                      :value="idDocType.value"
                      default
                      :disabled="!isEditEnabled">
                      {{ idDocType.label }}
                    </d-form-radio>
                  </div>
                </div>
              </d-col>
              <d-col md="6" class="form-group">
                <label for="id_card">Nr dokumentu tożsamości</label>
                <d-input
                  id="id_card"
                  name="id_card"
                  v-model="data.id_card"
                  v-mask="getSelectedDocTypeMask(data.id_card_type)"
                  placeholder="Nr dokumentu tożsamości"
                  :disabled="!isEditEnabled"/>
              </d-col>
            </d-row>
            <d-row>
              <d-col md="6" class="form-group">
                <label>Stan cywilny</label>
                <v-select
                  v-model="data.marital_status"
                  :options="ClientUtils._marital_statuses"
                  :reduce="(option) => option.value"
                  :disabled="!isEditEnabled"
                  placeholder="Wybierz stan cywilny"
                  class="autocomplete-wrapper"
                  label="name">
                  <template slot="no-options">
                    Brak wyników
                  </template>
                </v-select>
              </d-col>
              <d-col
                v-if="data.marital_status === 1"
                md="6" class="form-group">
                <label>Rozdzielność majątkowa</label>
                <v-select
                  v-model="data.property_separation"
                  :options="ClientUtils._property_separations"
                  :reduce="(option) => option.value"
                  :searchable="false"
                  :disabled="!isEditEnabled"
                  placeholder="Wybierz opcję"
                  class="autocomplete-wrapper"
                  label="name">
                  <template slot="no-options">
                    Brak wyników
                  </template>
                </v-select>
              </d-col>
              <d-col
                v-if="data.marital_status === 2"
                md="6" class="form-group">
                <label for="name">Opis stanu cywilnego</label>
                <textarea
                  type="text"
                  name="marital_status_other"
                  v-validate="'required'"
                  v-model="data.marital_status_other"
                  :disabled="!isEditEnabled"
                  :rows="2"
                  :class="{
                    'form-control': true,
                    'is-invalid' : errors.first('marital_status_other')
                    }"
                  placeholder="Opis..." />
                <div class="invalid-feedback">{{ errors.first('marital_status_other') }}</div>
              </d-col>
            </d-row>
            <d-row>
              <d-col md="6" class="form-group">
                <ss-input
                  v-model="data.residence_street"
                  name="residence_street"
                  label="Ulica"
                  placeholder="Ulica"
                  :disabled="!isEditEnabled">
                </ss-input>
              </d-col>
              <d-col md="3" class="form-group">
                <ss-input
                  v-model="data.residence_house_number"
                  name="residence_house_number"
                  label="Nr budynku"
                  placeholder="Nr budynku"
                  :disabled="!isEditEnabled">
                </ss-input>
              </d-col>
              <d-col md="3" class="form-group">
                <ss-input
                  v-model="data.residence_flat_number"
                  name="residence_flat_number"
                  label="Nr mieszkania"
                  placeholder="Nr mieszkania"
                  :disabled="!isEditEnabled">
                </ss-input>
              </d-col>
            </d-row>

            <d-row>
              <d-col md="6" class="form-group">
                <ss-input
                  v-model="data.residence_postcode"
                  name="residence_postcode"
                  label="Kod pocztowy"
                  placeholder="Kod pocztowy"
                  mask="##-###"
                  :disabled="!isEditEnabled">
                </ss-input>
              </d-col>
              <d-col md="6" class="form-group">
                <ss-input
                  v-model="data.residence_city"
                  name="residence_city"
                  label="Miasto"
                  placeholder="Miasto"
                  :disabled="!isEditEnabled">
                </ss-input>
              </d-col>
            </d-row>
          </d-form>
        </template>
      </div>
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i>Zamknij
      </d-button>
      <d-button
        @click.prevent="validateForm"
        :class="{ isLoading: actionInProgress }"
        theme="success" class="ml-3"
        :disabled="!isNewRep && !data.id">
        <i class="material-icons">save</i>
        <template v-if="representativeIndex !== null">
          Zapisz
        </template>
        <template v-else-if="!isNewRep && !isEditEnabled">
          Dodaj
        </template>
        <template v-else>
          Zapisz i dodaj
        </template>
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import ClientUtils from '@/utils/client.js';
import FormUtils from '@/utils/FormUtils.js';
import IdDocumentsTypes from '@/data/id-documents-types.js';
import SsModal from '@/components/common/SsModal'

export default {
  name: 'RepresentativeFormModal',
  components: {
    SsModal
  },
  props: {
    allClientRepresentativesIds: {
      default: () => [],
      type: Array
    },
    allRepresentativesLite: {
      default: () => [],
      type: Array
    }
  },
  computed: {
    isAllDataLoaded () {
      return this.loaded && !this.actionInProgress;
    },
    idDocumentsTypes () {
      return IdDocumentsTypes;
    },
    ClientUtils () {
      return ClientUtils;
    }
  },
  watch: {
    isNewRep (newValue) {
      if (!this.isModalVisible) {
        return;
      }
      Vue.set(this, 'data', _.clone(ClientUtils._representative));

      if (newValue) {
        this.isEditEnabled = true;
        return;
      }

      this.isEditEnabled = false;
    }
  },
  data () {
    return {
      data: {
        id: 0,
        email: null,
        phone: null,
        name: '',
        surname: '',
        id_card: null,
        id_card_type: 'id',
        residence_street: null,
        residence_house_number: null,
        residence_flat_number: null,
        residence_postcode: null,
        residence_city: null,
        property_separation: null,
        marital_status: null,
        marital_status_other: ''
      },
      loaded: false,
      loadError: false,
      actionInProgress: false,
      representativeIndex: null,
      isModalVisible: false,
      isEditEnabled: false,
      isNewRep: true
    }
  },
  mounted () {
    this.loaded = true;
  },
  methods: {
    showModal (selectedRepresentative = null, representativeIndex = null) {
      Vue.set(this, 'representativeIndex', representativeIndex);

      if (selectedRepresentative === null) {
        Vue.set(this, 'data', _.clone(ClientUtils._representative));
        Vue.set(this, 'isNewRep', true);
        Vue.set(this, 'isEditEnabled', true);
      } else {
        Vue.set(this, 'data', JSON.parse(JSON.stringify(selectedRepresentative)));
        Vue.set(this, 'isNewRep', false);
        Vue.set(this, 'isEditEnabled', false);
      }

      this.resetFormValidation();

      this.$nextTick(() => {
        this.isModalVisible = true;
      })
    },
    closeModal (isSave = false) {
      this.$validator.reset()
      .then(() => {
        this.isModalVisible = false;
        if (isSave) {
          this.$emit('add-representative', this.data, this.representativeIndex, this.isEditEnabled);
        }
      })
    },
    resetFormValidation () {
      this.$validator.pause();
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    },
    fetchRepresentative (repID) {
      if (!repID) {
        return;
      }

      this.loaded = false;

      FormUtils.loadItemData(this, {
        method: 'post',
        endpointBase: '/api/representatives/get-representative',
        id: null,
        params: {
          id: repID
        },
        instanceFields: Object.keys(this.ClientUtils._representative),
        loadedKey: 'loaded'
      });
    },
    getSelectedDocTypeMask (docType) {
      let foundType = this.idDocumentsTypes.find(item => item.value === docType);
      if (foundType) {
        return foundType.mask;
      }

      return 'AAA######';
    },
    validateForm () {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }

        this.saveRepresentative();
      });
    },
    saveRepresentative () {
      if (!this.isEditEnabled) {
        this.closeModal(true);
        return;
      }

      Vue.set(this, 'actionInProgress', true);
      FormUtils.submit(this, {
        endpoint: '/api/representatives/save-representative',
        formData: this.data,
        successTitle: 'Przedstawiciel został zapisany.',
        successText: '',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapisywanie przedstawiciela nie powiodło się. Spróbuj ponownie.',
        successAction: (response) => {
          if (!this.data.id) {
            Vue.set(this.data, 'id', response.id);
          }

          this.closeModal(true);
          Vue.set(this, 'actionInProgress', false);
        },
        failAction: (error) => {
          Vue.set(this, 'actionInProgress', false);
        }
      });
    }
  }
}
</script>